module.exports = __webpack_public_path__ + "img/MapPicsBanditCanyon.284c3c70.webp";